export class EditPreferencesController {

  constructor($scope, $rootScope, $http, toastr, UserService, AuthService) {
    $scope.vm = this;
    this.scope = $scope;
    this.http = $http;
    this.toastr = toastr;
    this.rootScope = $rootScope;
    this.UserService = UserService;
    this.AuthService = AuthService;
    this.scope.formData = { currentPassword : ''};
    this.init();
  }

  init(){
    this.UserService.getCurrentUser()
      .then((response) => { let user = response.data;
        this.rootScope.currentUserProfile = user.data;
      })
      .catch((response) => { let error = response.data;
        console.log(error);
      });
  }

  changePassword() {
    if (!!this.scope.newPassword) {
      if (confirm('?Sequro que quieres cambiar la Clave a tu perfil?')) {
        var params = {
          _id: this.rootScope.currentUserProfile._id,
          password: this.scope.newPassword
        };

        this.UserService.changePassword(params)
          .then((response) => { let responce = response.data;
            this.toastr.info('Password actualizada con exito');
          })
          .catch((response) => { let err = response.data;
            console.error(err);
          });
      }
    } else {
      this.toastr.error('Debes ingresar tu password');
    }
  }
  saveNotifications(){
    var params = {
      _id: this.rootScope.currentUserProfile._id,
      notifications: this.rootScope.currentUserProfile.notifications
    };

    this.UserService.changeNotifications(params)
      .then((response) => { let responce = response.data; let status = response.status;
        this.toastr.info('Se han guardado los cambios.');
      })
      .catch((response) => { let error = response.data; let status = response.status;
        if(status == 409){
          this.toastr.warning('No hay cambios para guardar.');
        }
      });
  }

  deactivateProfile(password) {
    if (! password) {
      this.toastr.warning('Please, insert your password before deactivation');
      return;
    }

    this.UserService.deactivateProfile(this.rootScope.currentUserProfile._id, password)
      .then((response) => { let result = response.data;
          if (result.success) {
            this.toastr.info('Profile has been deactivated');
            this.rootScope.currentUserProfile = result.data;
            this.scope.formData.currentPassword = '';
            this.AuthService.logout();
          }
          else {
            this.toastr.warning( result.message );
          }
      })
      .catch((response) => { let err = response.data;
        this.toastr.warning('Profile deactivation error');
        console.log(err);
      })
  }

  activateProfile(password) {
    if (!password) {
      this.toastr.warning('Please, insert your password before activation');
      return;
    }

    this.UserService.activateProfile(this.rootScope.currentUserProfile._id, password)
      .then((response) => { let result = response.data;
        if (result.success) {
          this.toastr.info('Profile has been activated');
          this.rootScope.currentUserProfile.status = result.data.status;
          this.scope.formData.currentPassword = '';
        }
        else {
          this.toastr.warning( result.message );
        }
      })
      .catch((response) => { let err = response.data;
        this.toastr.warning('Profile activation error');
        console.log(err);
      })
  }
}
